
export interface AddressApiFormat {
  name: string;
  latitude: number;
  longitude: number;
}

/**
 * Convert address details to API format
 * @param addressString - The address string entered by user
 * @param placeDetails - Google Places API result (optional)
 * @returns Address in API format or undefined if no address
 */
export const convertAddressToApiFormat = (
  addressString: string,
  placeDetails?: google.maps.places.PlaceResult
): AddressApiFormat | undefined => {
  if (!addressString) {
    console.log('No address string provided');
    return undefined;
  }

  if (placeDetails?.geometry?.location) {
    try {
      let lat: number;
      let lng: number;

      const location = placeDetails.geometry.location;

      if (typeof location.lat === 'function' && typeof location.lng === 'function') {
        lat = location.lat();
        lng = location.lng();
      }
      else if (typeof location.lat === 'number' && typeof location.lng === 'number') {
        //@ts-expect-error
        lat = location.lat;
        //@ts-expect-error
        lng = location.lng;
      }
      else {
        const loc = location as any;
        lat = loc.lat || loc.latitude || 0;
        lng = loc.lng || loc.longitude || 0;
      }

      console.log('📊 Extracted coordinates:', { lat, lng });

      if (lat !== 0 && lng !== 0) {
        const result = {
          name: addressString,
          latitude: lat,
          longitude: lng,
        };
        return result;
      } else {
        console.log('Coordinates are zero, treating as invalid');
      }
    } catch (error) {
      console.error('🔴 Error extracting coordinates:', error);
    }
  }

  console.warn(`⚠️ No valid coordinates available for address: ${addressString}`);
  return {
    name: addressString,
    latitude: 0,
    longitude: 0,
  };
};
